<template>
    <div id="video-component" ref="video-component" v-on:click="exit">
        <picture>
            <source :srcset="$url + 'img/bg_acesso.webp'" type="image/webp">
            <source :srcset="$url + 'img/bg_acesso.png'" type="image/png"> 
            <img id="bg" :src="$url + 'img/bg_acesso.webp'">
        </picture>
        <img id="raio" :src="$url + 'img/coleta/raios_desafio.png'">
        <img id="star" :src="$url + 'img/coleta/estrelas_desafio.png'">
        <img id="icon" :src="$url + 'img/coleta/icone_desafio.png'">
        <transition name="fade">
            <div v-if="show" id="box">
                <h3>Vídeo</h3>
                <span><a href="#"><img :src="$url + 'img/fechar.png'"></a></span>
                <br>
                <!-- <iframe src="https://www.youtube.com/embed/vGHrJDmepI0?rel=0;controls=0;showinfo=0;theme=light" allowfullscreen="" width="420" height="235" frameborder="0"> -->

                <div class='embed-container'><iframe src='https://www.youtube.com/embed/-WB7Rq5SNR4?start=65' frameborder='0' allowfullscreen></iframe></div>
            </div>
        </transition>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
        name: "VideoComponent",
        data() {
            return {
                show: false
            }
        },
        computed: {
            ...mapGetters(['item', 'itens', 'itens_ref', 'itens_frase', 'itens_name'])
        },
        methods: {
            start(itens, total_itens) {
                itens, total_itens;

                
                this.$parent.view_video = true;
                this.show = true;
            },
            yes() {
                this.$parent.focusGame();
                this.$parent.view_video = false;
            },
            exit() {
                this.$parent.focusGame();
                this.$parent.view_video = false;
            }
        },
        mounted() {
            
        }
    }
</script>
<style scoped>
    #bg
    {
        background-color: white;
        bottom: 0;
        height: 872px;
        left: calc(50% - 960px);
        position: fixed;
        width: 1920px;
        
    }
    #video-component {
        background-color: rgba(0, 0, 0, .5);
        height: 100%;
        left: 0;
        position: absolute;
        top: 100;
        width: 100%;
        
    }
    #raio
    {
        height: 701px;
        left: calc(50% - 350px);
        position: absolute;
        top: 100;
        width: 701px;
    }
    #star
    {
        height: 585px;
        left: calc(50% - 292px);
        position: absolute;
        top: 100;
        width: 585px;
    }
    #icon
    {
        height: 175px;
        left: calc(50% - 80px);
        position: absolute;
        top: 90px;
        width: 198px;
    }
    #box
    {
        background-color: #fff;
        border-bottom: solid 70px #9dca26;
        border-radius: 30px;
        box-shadow: 2px 2px 2px rgba(0, 0, 0, .1);
        box-sizing: border-box;
        color: #777;
        display: block;
        height: auto;
        left: calc(50% - 500px);
        margin-bottom: 50px;
        min-height: 400px;
        padding: 10px;
        position: absolute;
        text-align: center;
        top: 200px;
        width: 1000px;
    }
    


    h3
    {
        background-color: #9dca26;
        border-bottom: solid 2px rgba(0, 0, 0, .05);
        border-radius: 15px;
        box-shadow: 0 -1px 0 rgba(255, 255, 255, .5);
        box-sizing: border-box;
        color: white;
        margin: 0 auto;
        padding: 15px;
        width: 180px;
    }
    span
    {
        position: absolute;
        right: -30px;
        top: -30px;
    }


    .fade-enter-active, .fade-leave-active {
        top: 200px;
        opacity: 1;
        transition: all .5s ease-out;
    }
    .fade-enter, .fade-leave-to {
        top: 250px;
        opacity: 0;
    }

    @media screen and (max-width: 980px)
    {
        #box
        {
            left: 10%;
            width: 80%;
        }
    }










    .embed-container { position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; max-width: 100%; } .embed-container iframe, .embed-container object, .embed-container embed { position: absolute; top: 0; left: 0; width: 100%; height: 100%; }
</style>